import { render, staticRenderFns } from "./colonne_statut.vue?vue&type=template&id=2b34d1ee"
import script from "./colonne_statut.js?vue&type=script&lang=js&external"
export * from "./colonne_statut.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports